function cov_aakjxxoxi() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/MultipleOffers.tsx";
  var hash = "0840d07822b9cbb6b673aec3e636ac815114f274";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/MultipleOffers.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 55
        },
        end: {
          line: 8,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "0840d07822b9cbb6b673aec3e636ac815114f274"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_aakjxxoxi = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_aakjxxoxi();
var Icon = (cov_aakjxxoxi().s[0]++, {
  name: 'multiple-offers',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.5 8.5V19.5H14.9V8.5H5.5ZM5.4 6C4.07452 6 3 7.07452 3 8.4V19.6C3 20.9255 4.07452 22 5.4 22H15C16.3255 22 17.4 20.9255 17.4 19.6V8.4C17.4 7.07452 16.3255 6 15 6H5.4Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.75 5C7.75 3.20507 9.20507 1.75 11 1.75H18.4C20.1949 1.75 21.65 3.20507 21.65 5V15.6C21.65 17.3397 20.2397 18.75 18.5 18.75V16.25C18.859 16.25 19.15 15.959 19.15 15.6V5C19.15 4.58579 18.8142 4.25 18.4 4.25H11C10.5858 4.25 10.25 4.58579 10.25 5H7.75Z\" fill=\"currentColor\"/>\n  <path d=\"M8.19995 10.8398C8.19995 11.3921 7.75224 11.8398 7.19995 11.8398C6.64767 11.8398 6.19995 11.3921 6.19995 10.8398C6.19995 10.2876 6.64767 9.83984 7.19995 9.83984C7.75224 9.83984 8.19995 10.2876 8.19995 10.8398Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.75 14C6.75 13.3096 7.30964 12.75 8 12.75H12C12.6904 12.75 13.25 13.3096 13.25 14C13.25 14.6904 12.6904 15.25 12 15.25H8C7.30964 15.25 6.75 14.6904 6.75 14Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.75 17.2002C6.75 16.5098 7.30964 15.9502 8 15.9502H12C12.6904 15.9502 13.25 16.5098 13.25 17.2002C13.25 17.8906 12.6904 18.4502 12 18.4502H8C7.30964 18.4502 6.75 17.8906 6.75 17.2002Z\" fill=\"currentColor\"/>"
});
export default Icon;